//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamGrafObsahDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-04-17                                                  </Created>
//  </FileHeader>

// tento script bude strojně generován podle XML předpisu definujícího SEZNAM

/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamGrafObsahDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamGrafObsahDesigner extends SeznamBase {

        /** z detail okna předaný atribut pro filtr seznamu */
        public ixs_grf: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GGrafObsahDto>;

        /**
         * SeznamGrafObsahDesignerInit
         * 
         * @param {GContentType<SeznamGrafObsahDesigner>} that
         */
        static SeznamGrafObsahDesignerInit(that: GContentType<SeznamGrafObsahDesigner>) {

            that.gridSearchColumns = "ixs_grf, dat_od, dat_do".split(",");

            SeznamBase.SeznamBaseInit(that as GContentType<SeznamBase>);

            that.filter = this.createFilter(that);

            that.gridFormat = this.createGridFormat(that);

            that.view = new Gordic.Isl.View(that.isl.GrafObsah.list(), { filterPanel: that.filter, startEmpty: false, });       // propojení ovládacího prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamGrafObsahDesignerInit


        /** vytvořit formát seznamu - definice sloupců, napdpisů, šířek atd... */
        static createGridFormat(that: GContentType<SeznamGrafObsahDesigner>): Gordic.Data.GridFormat {

            var columnsDefinition = this.createGridFormatBase(that);

            columnsDefinition
                .addDateTimeColumn({
                    name: "dat_od",
                    caption: "jres:32131055", //RC 32131055 : Datum OD
                    width: 150,
                    fragment: ""
                })
                .addDateTimeColumn({
                    name: "dat_do",
                    caption: "jres:32131056", //RC 32131056 : Datum DO
                    width: 150,
                    fragment: ""
                })
                .addNumberColumn({
                    name: "grf_count",
                    caption: "jres:32131094", //RC 32131094 : Počet
                    width: 150,
                    fragment: "seznam"
                })
                .addNumberColumn({
                    name: "grf_sum",
                    caption: "jres:32131095", //RC 32131095 : Součet
                    width: 150,
                    fragment: "seznam"
                })
                


            return columnsDefinition;
        } // createGridFormat

        /** vytvořit formulář filtru - panel */
        static createFilter(that: GContentType<SeznamGrafObsahDesigner>): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true);

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okamžitému načtení dat do seznamu podle nastaveného filtru

            return (v_filter);
        } // createFilter

        /** vytvořit formulář filtru - vytvoří tam filtrační políčka */
        static createFilterForm(that: GContentType<SeznamGrafObsahDesigner>): Forms.Form {

            // vytvořím form
            var v_filterForm = SeznamBase.createFilterFormBase(that);


            //var startOfDay = moment().startOf('day').toDate();
            //var endOfDay = moment().endOf('day').toDate();

            // přidám do něj políčka
            v_filterForm
                //.addRow({
                //    label: "jres:32131091"	 //RC 32131091 : Graf
                //})
                //.addField("gselectbox", Gordic.Prefabs.Select.ginsgrf(), {
                //    initialValue: { ixs_grf: that.ixs_grf || "" },                              // u readereu se musí nastavit jako objekt s pojmenovanou hodnotou
                //    dropdown: true,                                                             // políčko jako combobox
                //    name: "ixs_grf",                                                            // název položky
                //    model: "model.ixs_grf=value.ixs_grf",                                       // model je to, co je na teto strance , value je to, co je v políčku
                //    customClass: "w-8",
                //    disabled: true                                                              // editace je zakázaná
                //})
                .addRow({
                    label: "jres:32131091"	 //RC 32131091 : Graf
                })
                .addField("gstringbox", {					
                    initialValue: that.ixs_grf || "",
                    name: "ixs_grf",
                    customClass: "w-8",
                    disabled: true,
                })
                .addRow({ label: "jres:32131097" })			 //RC 32131097 : Datum od
                .addField("gdatebox", {
                    disabled: false,
                    name: "dat_od",
                    valueType: "date"
                }) 
                .addRow({ label: "jres:32131098" })			 //RC 32131098 : Datum do
                .addField("gdatebox", {
                    disabled: false,
                    name: "dat_do",
                    valueType: "date"
                }) 
            return v_filterForm;
        } // createFilterForm
    }


}